<template>
  <div class="header-trigger-icon">
    <BackstageIcon :name="iconName" :data-cy="dataCy" />
  </div>
</template>

<script setup lang="ts">
import BackstageIcon from '@/components/common/BackstageIcon.vue';
import type { IconValues } from '@/models/icons.enum';
defineProps<{
  dataCy: string;
  iconName: IconValues;
}>();
</script>

<style scoped lang="scss">
.header-trigger-icon {
  @include center-flex;
  padding: 9px;
  border-radius: 50%;
  border: 1px solid var(--primary-text-color);
  cursor: pointer;
  &:hover {
    background-color: var(--shade-2);
  }
}
</style>
